module.exports = __webpack_public_path__ + "img/logo.71683e19.svg";